// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__zAegx","loaderWhite":"Loader_loaderWhite__woNI6","loader-white":"Loader_loader-white__xhLk3"};